<script>
	import {onMount} from "svelte";

	export let dataMapUnit;
	import {Notebook} from '@manaakiwhenua/frag-svelte/src/index';
	import {default as mapUnitFactsheet} from '../notebooks/@ridgenb/map-unit-factsheet';

	let container;

	let width = 1024;

	function onResize() {
		if (container) {
			try {
				width = container.querySelector('[data-cell=chartBar]').getBoundingClientRect().width;
			} catch (e) {

			}

		}
	}

	onMount(onResize);

	//let cells = ['displayMap'];
	const cells = ['chartDesc4', 'chartBar', 'chartBarLegend1', 'chartBarLegend2', 'tableDesc', 'tableSibling'];
	//let cells = ['displayTextureGraph'];
	$: overrides = new Map([['dataMapUnitBar', dataMapUnit], ['width', width]]);
</script>

<style>
	.proportion-chart > :global(.frag-notebook) {
		display: grid;
		grid-template-areas:
			"description description"
			"chart chartBarLegend1"
			"chart chartBarLegend2"
			"tableDesc tableDesc"
			"tableSibling tableSibling";
		grid-template-columns: 1fr 200px;
		grid-template-rows: auto;
	}

	@media (max-width: 1023px) {
		.proportion-chart > :global(.frag-notebook) {
			grid-template-areas:
			"description description"
			"chart chart"
			"chartBarLegend1 chartBarLegend2"
			"tableDesc tableDesc"
			"tableSibling tableSibling";
			grid-template-columns: 50% 50%;
			grid-template-rows: auto;
		}
	}



	.proportion-chart > :global(.frag-notebook [data-cell=chartDesc4]) {
		grid-area: description;
	}

	.proportion-chart > :global(.frag-notebook [data-cell=chartBar]) {
		grid-area: chart;
	}

	.proportion-chart > :global(.frag-notebook [data-cell=chartBarLegend1]) {
		grid-area: chartBarLegend1;
		text-align: center;
		padding-left: 0.5em;
	}

	.proportion-chart > :global(.frag-notebook [data-cell=chartBarLegend2]) {
		grid-area: chartBarLegend2;
		text-align: center;
		padding-left: 0.5em;
	}

	.proportion-chart > :global(.frag-notebook [data-cell=tableDesc]) {
		grid-area: tableDesc;
	}

	.proportion-chart > :global(.frag-notebook [data-cell=tableSibling]) {
		grid-area: tableSibling;
		width: 100%;
		overflow-x: auto;
	}

	.proportion-chart > :global(.frag-notebook [data-cell=tableSibling] > table) {
		min-width: 600px;
		width: 100%;
	}

	.proportion-chart > :global(.frag-notebook [data-cell=tableSibling] > table th:nth-child(2)) {
		position: sticky;
		left: 0;
		z-index: 2;
	}

	.proportion-chart > :global(.frag-notebook [data-cell=tableSibling] > table td:nth-child(2)) {
		position: sticky;
		left: 0;
		background: white;
		z-index: 2;
	}

	.proportion-chart > :global([data-cell=tableSibling] table) {
		width: 100%;
	}

	@media screen and (max-width: 440px) {
		.proportion-chart > :global(.frag-notebook) {
			grid-template-areas:
			"description"
			"chart"
			"chartBarLegend1"
			"chartBarLegend2"
			"tableDesc"
			"tableSibling";
			grid-template-columns: 100%;
			grid-template-rows: auto;
		}

		.proportion-chart > :global(.frag-notebook [data-cell=chartBarLegend1]) {
			text-align: left;
		}

		.proportion-chart > :global(.frag-notebook [data-cell=chartBarLegend2]) {
			text-align: left;
		}
	}

	@media print {
		.proportion-chart {
			break-before: page;
		}
	}
</style>

<svelte:window on:resize={onResize}/>

<div class="proportion-chart" bind:this={container}>
	<Notebook notebook={mapUnitFactsheet} cells={cells} overrides={overrides} redefineWidth={true}></Notebook>
</div>
